export default __webpack_public_path__ + "static/media/strong.7809f806.jpg";